/* SOFLETE Training — static interactions (no framework).
 * Page chrome (theme, plan, scroll) + the interactive phone-mock widgets
 * (readiness metric selection, recipe portion toggle) reimplemented in vanilla
 * JS. Widget logic is a faithful port of the original React-effect versions. */
(function () {
  "use strict";

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  /* ---------------- Page chrome: theme toggle, plan select, CTA scroll --------------- */
  function initChrome() {
    var roots = document.querySelectorAll(".sflt-root");
    function currentTheme() { var r = roots[0]; return (r && r.getAttribute("data-theme")) || "dark"; }
    function applyTheme(m, persist) {
      roots.forEach(function (r) { r.setAttribute("data-theme", m); });
      if (persist) { try { localStorage.setItem("sof-theme", m); } catch (e) {} }
      document.querySelectorAll(".sof-toggle button").forEach(function (b) {
        b.setAttribute("aria-pressed", String((b.textContent || "").trim().toLowerCase() === m));
      });
    }
    var saved = null; try { saved = localStorage.getItem("sof-theme"); } catch (e) {}
    applyTheme(saved || currentTheme(), false);   // load: restore, but don't write storage (keeps the toggle hint's "new visitor" check valid)
    document.querySelectorAll(".sof-toggle button").forEach(function (b) {
      b.addEventListener("click", function () { applyTheme((b.textContent || "").trim().toLowerCase(), true); });
    });
    var heroTgl = document.querySelector(".tgl");
    if (heroTgl) heroTgl.addEventListener("click", function () {
      applyTheme(currentTheme() === "dark" ? "light" : "dark", true);
    });
    function scrollToTrial() {
      var el = document.getElementById("trial-anchor");
      if (el) window.scrollTo({ top: el.offsetTop - 80, behavior: "smooth" });
    }
    document.querySelectorAll(".sof-enlist, .sof-btn-primary, .sof-store-btn").forEach(function (b) {
      if (b.type === "submit" || b.closest("form")) return; // real add-to-cart buttons submit; don't hijack
      b.addEventListener("click", scrollToTrial);
    });
    var planForm = document.querySelector(".sof-plans");
    if (planForm) {
      var spInput = document.getElementById("sflt-selling-plan");
      var radios = planForm.querySelectorAll('input[type="radio"][name="plan-id"]');
      var syncPlan = function () {
        radios.forEach(function (r) { var lbl = r.closest(".sof-plan"); if (lbl) lbl.classList.toggle("on", r.checked); });
        var checked = planForm.querySelector('input[type="radio"][name="plan-id"]:checked');
        if (spInput && checked) spInput.value = checked.getAttribute("data-selling-plan") || "";
      };
      radios.forEach(function (r) { r.addEventListener("change", syncPlan); });
      syncPlan();
    }
  }

  /* ---------------- Readiness card: clickable metric tiles + trend chart ------------- */
  var NS = "http://www.w3.org/2000/svg";
  var DAYS = ["TUE", "WED", "THU", "FRI", "SAT", "SUN", "MON"];
  var ORDER = ["sleep", "hr", "hrv", "rhr"];
  var X0 = 22, X1 = 278, YT = 14, YB = 74;

  function initReadiness(root, M, S) {
    if (!root) return;
    var svg = root.querySelector(S.svg), legend = root.querySelector(S.legend);
    var metrics = root.querySelector(S.metrics), detail = root.querySelector(S.detail);
    if (!svg || !metrics || !detail) return;
    var dTitle = root.querySelector(S.dTitle), dAvg = root.querySelector(S.dAvg), dRange = root.querySelector(S.dRange);
    var showAll = root.querySelector(S.showAll);
    var sel = null;

    function xFor(i) { return X0 + i * ((X1 - X0) / (DAYS.length - 1)); }
    function yFor(v, m) { var s = M[m].series, mn = Math.min.apply(0, s), mx = Math.max.apply(0, s); var t = mx === mn ? 0.5 : (v - mn) / (mx - mn); return YB - t * (YB - YT); }
    function pts(m) { return M[m].series.map(function (v, i) { return xFor(i) + "," + yFor(v, m).toFixed(1); }).join(" "); }
    function el(tag, attrs) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }
    function fmt(v, d) { return v.toFixed(d); }

    function render() {
      svg.textContent = "";
      [YT, (YT + YB) / 2, YB].forEach(function (y) { svg.appendChild(el("line", { x1: X0, y1: y, x2: X1, y2: y, stroke: "var(--line)", "stroke-width": 1 })); });
      ORDER.forEach(function (m) { if (sel && m !== sel) svg.appendChild(el("polyline", { fill: "none", stroke: M[m].color, "stroke-width": 1.5, opacity: .18, points: pts(m) })); });
      if (!sel) {
        ORDER.forEach(function (m) { svg.appendChild(el("polyline", { fill: "none", stroke: M[m].color, "stroke-width": 2, points: pts(m) })); });
      } else {
        var m = sel, s = M[m].series;
        svg.appendChild(el("polyline", { fill: "none", stroke: M[m].color, "stroke-width": 2.5, points: pts(m) }));
        s.forEach(function (v, i) {
          var cx = xFor(i), cy = yFor(v, m);
          svg.appendChild(el("circle", { cx: cx, cy: cy, r: 4, fill: M[m].color, stroke: "var(--card)", "stroke-width": 1.5 }));
          var t = el("text", { x: cx, y: cy - 8, "text-anchor": "middle", fill: M[m].color, style: "font-family:var(--font-mono);font-size:9px" });
          t.textContent = fmt(v, M[m].dec); svg.appendChild(t);
        });
      }
      DAYS.forEach(function (d, i) { var t = el("text", { x: xFor(i), y: 94, "text-anchor": "middle", fill: "var(--muted)", style: "font-family:var(--font-mono);font-size:9px" }); t.textContent = d; svg.appendChild(t); });
      legend.textContent = ""; legend.classList.toggle("has-sel", !!sel);
      ORDER.forEach(function (m) {
        var sp = document.createElement("span"); sp.style.setProperty("--mc", M[m].color);
        if (sel === m) sp.className = "sel";
        sp.innerHTML = '<i style="background:' + M[m].color + '"></i>' + M[m].label;
        sp.onclick = function () { pick(m); }; legend.appendChild(sp);
      });
      metrics.classList.toggle("has-sel", !!sel);
      metrics.querySelectorAll(".mt").forEach(function (t) { t.classList.toggle("sel", t.getAttribute("data-m") === sel); });
      if (sel) {
        var s2 = M[sel].series, avg = s2.reduce(function (a, b) { return a + b; }, 0) / s2.length;
        var mn = Math.min.apply(0, s2), mx = Math.max.apply(0, s2);
        detail.hidden = false; detail.style.setProperty("--mc", M[sel].color);
        dTitle.textContent = M[sel].label + " Details";
        dAvg.textContent = "7-day avg: " + fmt(avg, 1) + " " + M[sel].unit;
        dRange.textContent = fmt(mn, 1) + " - " + fmt(mx, 1) + " " + M[sel].unit;
        showAll.hidden = false;
      } else { detail.hidden = true; showAll.hidden = true; }
    }
    function pick(m) { sel = (sel === m ? null : m); render(); }

    metrics.querySelectorAll(".mt").forEach(function (t) { t.addEventListener("click", function () { pick(t.getAttribute("data-m")); }); });
    if (showAll) showAll.onclick = function () { sel = null; render(); };
    render();
  }

  var HERO_M = {
    sleep: { label: "Sleep", unit: "hrs", color: "var(--sleep)", dec: 1, series: [6.4, 6.9, 7.0, 7.2, 7.1, 7.2, 7.8] },
    hr:    { label: "AM HR", unit: "bpm", color: "var(--hr)",    dec: 0, series: [60, 59, 58, 57, 58, 56, 54] },
    hrv:   { label: "HRV",   unit: "ms",  color: "var(--hrv)",   dec: 0, series: [48, 50, 53, 51, 55, 54, 62] },
    rhr:   { label: "RHR",   unit: "bpm", color: "var(--rhr)",   dec: 0, series: [54, 53, 52, 53, 51, 51, 49] },
  };
  var RECOVERY_M = {
    sleep: { label: "Sleep", unit: "hrs", color: "var(--sleep)", dec: 1, series: [8.1, 7.4, 6.9, 7.2, 6.5, 6.0, 5.6] },
    hr:    { label: "AM HR", unit: "bpm", color: "var(--hr)",    dec: 0, series: [55, 57, 54, 58, 61, 68, 76] },
    hrv:   { label: "HRV",   unit: "ms",  color: "var(--hrv)",   dec: 0, series: [44, 40, 46, 33, 30, 24, 19] },
    rhr:   { label: "RHR",   unit: "bpm", color: "var(--rhr)",   dec: 0, series: [54, 57, 53, 60, 58, 63, 72] },
  };

  function initReadinessAll() {
    var hero = document.querySelector(".sof-phone-wrap");
    initReadiness(hero, HERO_M, { svg: "#rdSvg", legend: "#rdLegend", metrics: "#rdMetrics", detail: "#rdDetail", dTitle: "#rdDetailTitle", dAvg: "#rdDetailAvg", dRange: "#rdDetailRange", showAll: "#rdShowAll" });
    document.querySelectorAll(".rd-card").forEach(function (rc) {
      initReadiness(rc, RECOVERY_M, { svg: ".rd-svg", legend: ".legend", metrics: ".metrics", detail: ".rd-detail", dTitle: ".dt", dAvg: ".dsub", dRange: ".rval", showAll: ".showall" });
    });
  }

  /* ---------------- Workout screen: "Scale Workout" auto-scaling toggle -------------- */
  function initScaleToggle() {
    document.querySelectorAll(".wv-toggle").forEach(function (tgl) {
      var content = tgl.closest(".wv-content");
      if (!content) return;
      tgl.addEventListener("click", function () {
        var on = tgl.getAttribute("aria-checked") !== "true";
        tgl.setAttribute("aria-checked", on ? "true" : "false");
        content.setAttribute("data-scaling", on ? "on" : "off");
      });
    });
  }

  /* ---------------- Recipe screen: Meal/Snack portion toggle + servings ------------- */
  function initRecipe() {
    var root = document.querySelector(".rp-screen");
    if (!root) return;
    var MACROS = {
      meal:  { cal: 686, carbs: 77, fat: 21, protein: 46, fiber: 9, sugar: 14 },
      snack: { cal: 458, carbs: 51, fat: 14, protein: 31, fiber: 6, sugar: 9 },
    };
    var INGREDIENTS = [
      { nm: "Chicken Breast", meal: 220, snack: 145 },
      { nm: "Jasmine Rice (Cooked)", meal: 185, snack: 120 },
      { nm: "Broccoli Florets", meal: 120, snack: 80 },
      { nm: "Carrots", meal: 90, snack: 60 },
      { nm: "Red Onion", meal: 50, snack: 35 },
      { nm: "Dijon Mustard", meal: 22, snack: 15 },
      { nm: "Honey", meal: 18, snack: 12 },
      { nm: "Olive Oil", meal: 12, snack: 8 },
    ];
    var portion = "meal", servings = 1;
    function q(s) { return root.querySelector(s); }
    function render() {
      var m = MACROS[portion], s = servings, r = function (v) { return Math.round(v * s); };
      q(".rp-macros").innerHTML =
        "<b>" + r(m.cal) + "</b> Cal &nbsp; <b>" + r(m.carbs) + "g</b> Carbs &nbsp; <b>" + r(m.fat) + "g</b> Fat<br>" +
        "<b>" + r(m.protein) + "g</b> Protein &nbsp; <b>" + r(m.fiber) + "g</b> Fiber &nbsp; <b>" + r(m.sugar) + "g</b> Sugar";
      q(".rp-ingredients").innerHTML = INGREDIENTS.map(function (ing) {
        return '<div class="rp-ing"><span class="nm">' + ing.nm + '</span><span class="amt">' + r(ing[portion]) + '<span class="u">g</span></span></div>';
      }).join("");
      q(".rp-val").textContent = s;
    }
    function setPortion(p) {
      portion = p;
      q(".rp-meal").setAttribute("aria-pressed", p === "meal");
      q(".rp-snack").setAttribute("aria-pressed", p === "snack");
      render();
    }
    q(".rp-meal").onclick = function () { setPortion("meal"); };
    q(".rp-snack").onclick = function () { setPortion("snack"); };
    q(".rp-inc").onclick = function () { if (servings < 12) { servings++; render(); } };
    q(".rp-dec").onclick = function () { if (servings > 1) { servings--; render(); } };
    render();
  }

  /* ---------------- Cycle screen: "Read More" expands the description --------------- */
  function initCycleReadMore() {
    var root = document.querySelector(".cy-crop");
    if (!root) return;
    var btn = root.querySelector(".cy-readmore"), desc = root.querySelector(".cy-desc");
    if (!btn || !desc) return;
    var txt = root.querySelector(".cy-rmtext"), chev = root.querySelector(".cy-rmchev");
    var expanded = false;
    btn.addEventListener("click", function () {
      expanded = !expanded;
      desc.classList.toggle("cy-clip", !expanded);
      if (txt) txt.textContent = expanded ? "Read Less" : "Read More";
      if (chev) chev.innerHTML = expanded ? '<path d="M6 15l6-6 6 6"/>' : '<path d="M6 9l6 6 6-6"/>';
    });
  }

  /* ---------------- Reveal on scroll (subtle fade-up, once) ------------------------- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Theme-toggle discoverability: one pulse on first view ------------- */
  function initToggleHint() {
    var tgl = document.querySelector(".sof-phone-wrap .tgl");
    if (!tgl || !("IntersectionObserver" in window)) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var toggled = false; try { toggled = !!localStorage.getItem("sof-theme"); } catch (e) {}
    if (toggled) return; // returning visitor already knows it's tappable
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { tgl.classList.add("sflt-hint"); io.unobserve(e.target); } });
    }, { threshold: 0.6 });
    io.observe(tgl);
  }

  ready(function () {
    initChrome();
    initReadinessAll();
    initRecipe();
    initScaleToggle();
    initCycleReadMore();
    initReveal();
    initToggleHint();
  });
})();


    function addItemToCart(variant_id, qty, selling_plan) {
        // Prepare data
        const data = new URLSearchParams();
        data.append("id", variant_id);
        data.append("quantity", qty);
        data.append("selling_plan", selling_plan);
    
        // Create an XMLHttpRequest
        const xhr = new XMLHttpRequest();
        xhr.open("POST", "/cart/add.js", true);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    
        // Define the success callback
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
                window.location.href = "/discount/FREETRIAL?redirect=/cart";
            } else {
                console.error("Failed to add item to cart:", xhr.responseText);
            }
        };
    
        // Define the error callback
        xhr.onerror = function () {
            console.error("An error occurred during the request.");
        };
    
        // Send the request
        xhr.send(data.toString());
    }
    function handleAddToCart() {
      var selectedRadio = document.querySelector('input[name="plan-id"]:checked');
      if (selectedRadio) {
        var variantValue = selectedRadio.value; // first argument
        var quantity = 1;                     // second argument
        var planId = selectedRadio.getAttribute('data-selling-plan'); // third argument
        addItemToCart(variantValue, quantity, planId);
      } else {
        alert('Please select a plan.');
      }
    }

    function routeButtonClick(){
      if (document.querySelector('#AddToCart-481631862823')) {
       document.querySelector('#AddToCart-481631862823').click();
      } else {
        handleAddToCart();
      }
    }
